import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../rl-common/dialogs/core/dialog.service';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { SidePanelService } from '../../side-panel/core/side-panel.service';
import { AssignmentService } from '../core/assignment.service';
import { Assignment } from '../shared/assignment';

@Component({
  selector: 'rl-assignment-menu',
  templateUrl: './assignment-menu.component.html',
  styleUrls: ['./assignment-menu.component.scss']
})
export class AssignmentMenuComponent implements OnInit {

  @Input('assignment') asgmt : Assignment;

  @Output() onDelete = new EventEmitter<void>();

  constructor(private sidePanel : SidePanelService, private dialogService : DialogService, private translate : TranslateService, private assignmentService : AssignmentService) { }

  ngOnInit(): void {
  }

  edit = () => this.sidePanel.editItem(EntityType.ASSIGNMENT, this.asgmt);

  delete = () => this.dialogService.openDeleteDialog(`${this.translate.instant('list.assignments.deleteConfirm')}: ${this.asgmt.title}?`, () => this.assignmentService.delete(this.asgmt).subscribe(() => this.onDelete.emit()));
}
